// @flow
import React from "react";
import { FormGroup, Label, Input, Col, FormFeedback } from "reactstrap";
import { connect } from "react-redux";
import axios from "axios";
import Section from "../../components/Section";
import { updateField } from "../../../redux/actions/configActions";
import { updateAttribute } from "../../../redux/actions/generalActions";

import ModeSelection from "./config-form-subsections/ModeSelection";

import MachineSelection from "./config-form-subsections/MachineSelection";

const mapDispatchToProps = { updateField, updateAttribute };
const mapStateToProps = state => {
  const { configReducer, generalReducer } = state;
  return {
    config: configReducer.config,
    eventIdExists: generalReducer.eventIdExists
  };
};

class GeneralSettings extends React.Component {
  constructor(props) {
    super(props);

    const { config } = this.props;
    this.state = {
      eventIdExists: false,
      currentEventId: config.eventId
    };

    this.timer = null;
    // #region event binders
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleEventIdChange = this.handleEventIdChange.bind(this);
    // #endregion
  }
  // #region events

  handleChange(event) {
    this.props.updateField({ [event.target.name]: event.target.value });
  }

  handleCheckboxChange(event) {
    event.persist();
    const { config } = this.props;
    this.props.updateField({
      [event.target.name]: !config[event.target.name]
    });
  }

  async handleEventIdChange(event) {
    clearTimeout(this.timer);
    this.props.updateAttribute({ eventIdExists: false });
    event.persist();
    const newId = event.target.value;
    const { currentEventId } = this.state;
    this.props.updateField({
      eventId: newId
    });
    this.timer = setTimeout(() => {
      // If the user enters the current event's id or the field is empty then we don't run any checks
      if (newId && newId !== currentEventId) {
        const { config } = this.props;
        axios
          .get(
            process.env.REACT_APP_API_URL.concat(config.machineId, "/", newId)
          )
          .then(response => {
            if (response.data.length !== 0) {
              this.props.updateAttribute({ eventIdExists: true });
            } else {
              this.props.updateAttribute({ eventIdExists: false });
            }
          });
      }
    }, 500);
  }

  // #endregion
  render() {
    const { config, eventIdExists, nomode } = this.props;

    const eventIdExistsFormFeedback = eventIdExists ? (
      <FormFeedback>Event ID already exists.</FormFeedback>
    ) : null;

    return (
      <Section title="General" isOpen>
        {nomode ? null : <ModeSelection />}
        {config.eventId ? <MachineSelection/> : null}
        <FormGroup row>
          <Label for="eventId" sm={2}>
            Event ID
          </Label>
          <Col sm={10}>
            <Input
              invalid={eventIdExists}
              required
              value={config.eventId}
              type="number"
              name="eventId"
              id="eventId"
              onChange={this.handleEventIdChange}
            />
            {eventIdExistsFormFeedback}
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="eventName" sm={2}>
            Event name
          </Label>
          <Col sm={10}>
            <Input
              required
              value={config.eventName}
              type="text"
              name="eventName"
              id="eventName"
              onChange={this.handleChange}
            />
          </Col>
        </FormGroup>
      </Section>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GeneralSettings);



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/GeneralSettings.jsx